import { apmCaptureError } from '../../apm'

export const handleAddToCartErrorApm = (error: unknown): void => {
  apmCaptureError(
    new Error(
      'CART_INTERMEDIATE_ADD_TO_CART_BUY_TOGETHER_FAIL: failed to add product to the cart',
      {
        cause: error,
      },
    ),
  )
}
